import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

const LS_KEY = "gm_wishlist";
const loadLocal = () => {
  try { return new Set(JSON.parse(localStorage.getItem(LS_KEY) || "[]")); }
  catch { return new Set(); }
};
const saveLocal = (s) => localStorage.setItem(LS_KEY, JSON.stringify([...s]));

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState(loadLocal);
  const synced = useRef(false);

  // On sign-in, merge local hearts into the account then adopt the server set.
  useEffect(() => {
    if (!user) { synced.current = false; return; }
    if (synced.current) return;
    synced.current = true;
    api.post("/wishlist/sync", { product_ids: [...ids] })
      .then((r) => {
        const merged = new Set(r.data.product_ids);
        setIds(merged);
        saveLocal(merged);
      })
      .catch(() => {});
    // eslint-disable-next-line
  }, [user]);

  const has = useCallback((pid) => ids.has(pid), [ids]);

  const toggle = useCallback((pid) => {
    let adding = false;
    setIds((prev) => {
      const next = new Set(prev);
      adding = !next.has(pid);
      adding ? next.add(pid) : next.delete(pid);
      saveLocal(next);
      if (user) {
        if (adding) api.post("/wishlist", { product_id: pid }).catch(() => {});
        else api.delete(`/wishlist/${pid}`).catch(() => {});
      }
      return next;
    });
    return adding;
  }, [user]);

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, count: ids.size }}>
      {children}
    </WishlistContext.Provider>
  );
};
